import SSRIcon from '@ingka/ssr-icon';
import { useTranslation } from 'react-i18next';
import {
  Children,
  Content,
  ImageWrapper,
  Title,
  Wrapper,
  SlideShowWrapperliveshows,
  Label,
} from './style';
import AspectRatioImage from '../AspectRatioImage';
import styled from 'styled-components';
import { formatDateTime } from '../../utils/formatDate';
import calendarIcon from '@ingka/ssr-icon/paths/calendar';

type PropsType = {
  title: string;
  backgroundImage: {
    src: string;
    srcSet: string;
    ratio: 'square' | 'standard' | 'wide' | 'portrait';
    loading?: string;
  };
  description: string;
  eventPath: string;
  inSlideShow: boolean;
  label: string; // Add the 'label' property
};

const CarouselWrapperLive = styled.div`
  background: rgb(var(--colour-neutral-2, 245, 245, 245))
`;

const Description = styled.p`
  margin: 0;
`;

const ReadMoreLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-50);
  min-height: 3.5rem;
  margin: 20px;
  padding: 0 2rem;
  border-radius: 64px;
  background: rgb(var(--colour-interactive-primary-bg-default, 17, 17, 17));
  color: rgb(var(--colour-text-and-icon-5, 255, 255, 255));
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.4285714286;
  text-decoration: none;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.4, 1),
    transform 250ms cubic-bezier(0.4, 0, 0.4, 1);

  &:hover,
  &:focus {
    color: rgb(var(--colour-text-and-icon-5, 255, 255, 255));
    text-decoration: none;
  }

  &:hover {
    background: rgb(var(--colour-interactive-primary-bg-hover, 51, 51, 51));
  }

  &:active {
    background: rgb(var(--colour-interactive-primary-bg-pressed, 0, 0, 0));
    transform: scale(0.97);
  }

  &:focus-visible {
    box-shadow: 0 0 0 4px rgb(var(--colour-static-black, 17, 17, 17));
    outline: 2px solid rgb(var(--colour-static-white, 255, 255, 255));
    outline-offset: 4px;
  }

  .svg-icon {
    flex-shrink: 0;
  }
`;


const LiveBroadcastCard = ({ title,  // Specify the type for the destructured props
  backgroundImage,
  description,
  eventPath,
  inSlideShow,
  label,
}: PropsType) => {
  const { t } = useTranslation();
  const WrapperElement = inSlideShow ? SlideShowWrapperliveshows : Wrapper;
  return (
    <CarouselWrapperLive>
      <WrapperElement>
        <Content>
          <Label>{formatDateTime(label, '')}</Label>
          <Title>{title}</Title>
          <Children><Description>{description}</Description></Children>

        </Content>
        <ImageWrapper>
          <AspectRatioImage
            src={backgroundImage.src}
            srcSet={backgroundImage.src}
              
            ratio={backgroundImage.ratio}
            loading={backgroundImage.loading}
            alt=""
          />
        </ImageWrapper>

      </WrapperElement>
      <ReadMoreLink href={eventPath}>
        <SSRIcon paths={calendarIcon} aria-hidden="true" />
        <span>{t('event.readMore')}</span>
      </ReadMoreLink>
    </CarouselWrapperLive>
  );
};

export default LiveBroadcastCard;